import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { v4 as uuidv4 } from 'uuid';
import PeopleIcon from '@material-ui/icons/People';
import MaterialIcon from '@material-ui/core/Icon';
import BigButton from '~/styles/components/BigButton';
import SubTitle from '~/components/SubTitle';

import PatientMap from '~/pages/Maps/pages/Patient';
import BloodMap from '~/pages/Maps/pages/Blood';
import InfusionMap from '~/pages/Maps/pages/Infusion';
import EmergencyMap from '~/pages/Maps/pages/Emergency';

import { Container, Content, List } from './styles';

const routes = [
  {
    icon: <PeopleIcon />,
    routename: 'Pacientes',
    pathname: '/maps/patients',
    id: uuidv4(),
  },
  {
    icon: <MaterialIcon className="icon-blood-calendar" />,
    routename: 'Sangramentos',
    pathname: '/maps/bloods',
    id: uuidv4(),
  },
  {
    icon: <MaterialIcon className="icon-drug-calendar" />,
    routename: 'Infusões',
    pathname: '/maps/infusions',
    id: uuidv4(),
  },
  {
    icon: <MaterialIcon className="icon-emergency" />,
    routename: 'Emergências',
    pathname: '/maps/emergencies',
    id: uuidv4(),
  },
];

const Maps = () => {
  const history = useHistory();
  const { location } = history;

  function handleClick(page) {
    history.push(page);
  }

  useEffect(() => {
    const titles = {
      '/maps/bloods': 'Mapa de Sangramentos | ClickHemofilia',
      '/maps/infusions': 'Mapa de Infusões | ClickHemofilia',
      '/maps/emergencies': 'Mapa de Emergências | ClickHemofilia',
    };
    document.title = titles[location.pathname] || 'Mapa de Pacientes | ClickHemofilia';
  }, [location.pathname]);

  function handleTab(param) {
    switch (param) {
      case '/maps/patients':
        return <PatientMap />;

      case '/maps/bloods':
        return <BloodMap />;

      case '/maps/infusions':
        return <InfusionMap />;

      case '/maps/emergencies':
        return <EmergencyMap />;

      default:
        return <PatientMap />;
    }
  }

  return (
    <Container>
      <SubTitle>Visão do mapa</SubTitle>

      <List>
        {routes.map(({ id, pathname, routename, icon }, index) => {
          return (
            <BigButton
              key={id}
              onClick={() => handleClick(pathname)}
              icon={icon}
              selected={
                index === 0 && location.pathname === '/maps' // Select the first element when open page
                  ? true
                  : pathname === location.pathname
              }
            >
              {routename}
            </BigButton>
          );
        })}
      </List>

      <Content>{handleTab(location.pathname)}</Content>
    </Container>
  );
};

export default Maps;
